import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { beep } from "./beep.js"
import ErrorPopup from "./ErrorPopup.js"
import { LOGOUT_URL } from "./Constants.js"

const Logout = () => {
	const [error, setError] = useState("")
	const [status, setStatus] = useState("typing") // typing, submitting, or success

	const setHeaderCity = useStoreActions((actions) => actions.setHeaderCity)
	const setHeaderUser = useStoreActions((actions) => actions.setHeaderUser)
	const setLoggedIn = useStoreActions((actions) => actions.setLoggedIn)
	const setClientId = useStoreActions((actions) => actions.setClientId)
	const setNavSelected = useStoreActions((actions) => actions.setNavSelected)
	const Lastname = useStoreState((state) => state.Lastname)
	const Firstname = useStoreState((state) => state.Firstname)
	const Token = useStoreState((state) => state.Token)
	const setToken = useStoreActions((actions) => actions.setToken)
	const navigate = useNavigate()

	useEffect(() => {
		const do_logout = async () => {
			try {
				const logout_data = {
					uid: Token.login_id,
					cid: Token.client_id,
				}

				const { data } = await axios.post(LOGOUT_URL, logout_data)

				setLoggedIn(false)
				setClientId(0)
				setToken("")
				setNavSelected("")
				if (data.msg === "Success") {
					setStatus("success")
				}
				setHeaderCity("CR Cloud Technology")
				setHeaderUser("None")
			} catch (err) {
				setLoggedIn(false)
				setToken("")
				setNavSelected("")
				beep()
				setError(err)
				if (err.message === "Request failed with status code 401") {
					setError("Timeout")
				}
				if (err.message === "Request failed with status code 422") {
					setError("422")
				}
				if (err.message === "Request failed with status code 500") {
					setError("500")
				}
			}
			setTimeout(() => {
				// remove the message line
				setLoggedIn(false)
				navigate("/login")
			}, 3000)
		}
		do_logout()
	}, [])

	return (
		<main className="Main">
			<fieldset className="panel-sm">
				<legend>User Logout</legend>
				<ErrorPopup
					message={
						error === "Timeout" ? "Your session has timed out. Please login again." :
						error === "422" ? "Unable to use browser refresh button." :
						error === "500" ? "Unknown error — notify CR Cloud Technology." :
						error ? String(error) : ""
					}
					onClose={() => setError("")}
				/>
				{status === "success" && (
					<>
						<p className="successMsg">
							{Firstname} {Lastname} Logged Out Successfully
						</p>
						<br />
						<p className="successMsg">Station is Secure</p>
						<br />
					</>
				)}
			</fieldset>
		</main>
	)
}

export default Logout
